<script setup lang="ts">
/**
 * lazyView()'s error component: shown when a view's chunk failed to download (offline, or a deploy replaced the
 * chunk this tab still points at). The error itself is reported by App.vue's onErrorCaptured. A reload fetches the
 * current build, which is what fixes the stale-chunk case.
 */
function reloadPage(): void {
  window.location.reload();
}
</script>

<template>
  <div role="alert" class="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
    <p class="text-lg font-semibold">This section couldn't be loaded.</p>
    <p class="text-sm text-base-content/70">Check your connection, then reload the page.</p>
    <button type="button" class="btn btn-primary btn-sm" @click="reloadPage">Reload page</button>
  </div>
</template>
